module.exports = __webpack_public_path__ + "static/img/bb2.1104fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb2.png
// module id = XC96
// module chunks = 2